import React from 'react';
import { motion } from 'framer-motion';
export function ReframeSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden mt-[-30px] mb-[-30px]" data-id="element-111">
      {/* Subtle background element */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-112" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8 mt-[-30px] mb-[-30px]" data-id="element-114">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-zinc-500 line-through decoration-gold/30 decoration-2" data-id="element-115">
            They're not random.
          </h2>

          <h3 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white" data-id="element-116">
            They're{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-117">
              signals.
            </span>
          </h3>

          <p className="text-2xl sm:text-3xl text-zinc-300 font-serif pt-8 max-w-2xl mx-auto leading-relaxed" data-id="element-118">
            You just don't know
            <br data-id="element-119" />
            how to read them.
          </p>
        </motion.div>
      </div>
    </section>;
}